module.exports = __webpack_public_path__ + "media/components/assets/pause-btn-7742a900ed8d8db6b2ef72ac2170348f.svg";